






























































import { Invoice, MonthlyInvoice, Particular, SurchargeItem } from '@/types/entity';
import { ApiRequest } from '@/types/request';
import { MedTransGoConstants } from '@/util/constants';
import { DateUtils } from '@/util/dateUtils';
import { Component, Vue } from 'vue-property-decorator';
import '../../assets/css/ServiceRequestDetails.scss';
import { ObjectFactory } from '../../config/objectFactory';
import { MemberProfile } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import ChangePaymentModal from './ChangePaymentModal.vue';
import AddPaymentModal from './AddPaymentModal.vue';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
import { MathUtils } from '@/util/mathUtils';
@Component({
    props: {
        fileName: String,
        chargeInvoiceDetails: {
            type: Object,
            required: false,
            default: null,
        },
    },
    components: {
        ChangePaymentModal,
        AddPaymentModal,
    },
})
export default class ViewReceiptModal extends Vue {

    private show = true;
    private fileURL: any = '';
    private showPayInvoiceModal = false;
    private paymentCustomer: any = '';
    private customerPaymentId = '';
    private paymentCustomerId: string = '';
    private showChangePaymentForm = false;
    private showAddPaymentForm = false;
    private errorMessage = '';
    private memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();
    private updatedAmount = null;
    private updatedAmountIn$ = '';
    private billingLocations = [] as any;
    private billingLocationIds = [] as any;

    private async mounted() {
        if (this.$props.chargeInvoiceDetails && this.$props.chargeInvoiceDetails.isMasterInvoice
            && this.$props.chargeInvoiceDetails.billingStatementIds) {
            await this.getUpdatedTotalAmount(this.$props.chargeInvoiceDetails.billingStatementIds);
        }
        if (this.$props.chargeInvoiceDetails && this.$props.chargeInvoiceDetails.isMasterInvoice
            && this.$props.chargeInvoiceDetails.billingLocationIds) {
           this.billingLocationIds = this.$props.chargeInvoiceDetails.billingLocationIds;
           this.getBillingLocationsDetails(this.billingLocationIds);
        }
        if (this.$props.chargeInvoiceDetails && this.$props.chargeInvoiceDetails.billingLocation
                 && !this.$props.chargeInvoiceDetails.isMasterInvoice) {
            this.billingLocations.push(this.$props.chargeInvoiceDetails.billingLocation);
            this.billingLocationIds.push(this.$props.chargeInvoiceDetails.billingLocation.id);
        }
        if (this.$props.chargeInvoiceDetails && this.$props.chargeInvoiceDetails.particulars) {
            const lienServiceSurcharge = this.deleteSurchargeByName(
                this.$props.chargeInvoiceDetails.particulars,
                'Service Fee');
            if (lienServiceSurcharge) {
                let totalAmountInCents = MathUtils.convertDollarToCents(this.$props.chargeInvoiceDetails.amount);
                if (totalAmountInCents > 0 && lienServiceSurcharge.amount !== 3000) {
                    totalAmountInCents -= lienServiceSurcharge.amount;
                    this.$props.chargeInvoiceDetails.amount = MathUtils.formatCurrency(totalAmountInCents);
                }
            }
        }
        if (this.$route.query.orignal && this.$route.query.orignal === 'true') {
            this.displayOriginalInvoice(this.$route.params.id);
        } else if (this.$route.params.id) {
            this.getInvoiceReceipt(this.$route.params.id);
        } else if (this.$props.fileName) {
            this.showSubscriptionInvoice(this.$props.fileName);
        }
        if (this.$route.params.id) {
            this.saveInvoiceViewedOn(this.$route.params.id);
        }
    }


    /**
     * @author <Durga.S>
     * @description - Returns pdf file
     * @param req {Request} - Express Request - invoice Id
     * @param res {Response} - Express Response - pdf file
     * @returns patient details
     * @throws InvalidRequestException if invoice id is invalid
     */
   private async getInvoiceReceipt(id: string) {
        const pdfBuffer = await ObjectFactory.getInvoiceService().
        getInvoiceReceipt(this.$store.state.serverUrl, id) as any;
        const file = new Blob([pdfBuffer], {type: 'application/pdf'});
        this.fileURL = URL.createObjectURL(file);
    }

    private async displayOriginalInvoice(id: string) {
        const iHttpService = ObjectFactory.getHttpService();
        const invoiceApiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_INVOICE}/${id}`,
            timeout: 50000,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.get<Invoice>(invoiceApiRequest);
        if (response.success && response.data && response.data.originalPdfResourceId) {
            const fileName: string = response.data.originalPdfResourceId;
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_RESOURCE}/download/${fileName}`,
                loaderEvent: {
                    show: true,
                },
                responseType: 'arraybuffer',
            };
            const fileBuffer = await iHttpService.get<any>(apiRequest) as any;
            if (fileName.toLowerCase().endsWith('.pdf')) {
                const file = new Blob([fileBuffer], {type: 'application/pdf'});
                this.fileURL = URL.createObjectURL(file);
            }
        }
    }
    private async showSubscriptionInvoice(fileName: string) {
        this.fileURL = '';
        const iHttpService = ObjectFactory.getHttpService();
        if (fileName) {
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_RESOURCE}/download/${encodeURIComponent(fileName)}`,
                loaderEvent: {
                    show: true,
                },
                responseType: 'arraybuffer',
            };
            const fileBuffer = await iHttpService.get<any>(apiRequest) as any;
            if (fileName.toLowerCase().endsWith('.pdf')) {
                const file = new Blob([fileBuffer], {type: 'application/pdf'});
                this.fileURL = URL.createObjectURL(file);
            }
        }
    }

    private async saveInvoiceViewedOn(invoiceId: string) {
        const iHttpService = ObjectFactory.getHttpService();
        const updateRequest = {
            viewedOn: DateUtils.getCurrentUTCTimeInMillis(),
        };
        const invoiceApiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_INVOICE}/${invoiceId}/saveInvoiceViewedon`,
            data: updateRequest,
            timeout: 50000,
            loaderEvent: {
                show: true,
            },
        };
        await iHttpService.put<Invoice>(invoiceApiRequest);
    }

    private close() {
        if (this.$route.params.id) {
            this.$router.back();
        } else {
            this.$emit('close');
        }
    }

    private async showPaymentDetails() {
        await this.getPaymentCustomer();
        this.showPayInvoiceModal = true;
    }

    private async getPaymentCustomer() {
        if (!this.customerPaymentId) {
            const memberResponse = await ObjectFactory.getMemberService().
                    getMemberDetails(this.$store.state.serverUrl, this.memberProfile.memberId);
            if (memberResponse.success && memberResponse.data && memberResponse.data.paymentCustomerId) {
                this.customerPaymentId = memberResponse.data.paymentCustomerId;
                this.paymentCustomerId = memberResponse.data.paymentCustomerId;
            } else {
                this.paymentCustomer = '';
                return;
            }
        }
        const response = await ObjectFactory.getPaymentSourceService()
            .getPaymentCustomer(this.$store.state.serverUrl, this.customerPaymentId);
        this.paymentCustomer = response.data;
    }

    private async onPaymentCustomerChanged(payload: any ) {
        this.customerPaymentId = payload.customerId;
        this.paymentCustomerId = payload.customerId;
        const response = await ObjectFactory.getPaymentSourceService()
            .getPaymentCustomer(this.$store.state.serverUrl, this.customerPaymentId);
        this.paymentCustomer = response.data;
    }


    private async chargeInvoice() {
        const iHttpService = ObjectFactory.getHttpService();
        let url = '';
        if (this.$props.chargeInvoiceDetails.isMasterInvoice) {
            url = `${MedTransGoConstants.HTTP_URL_INVOICE}/${this.$props.chargeInvoiceDetails.invoiceId}/masterInvoice/charge`;
        } else {
            url = `${MedTransGoConstants.HTTP_URL_INVOICE}/${this.$props.chargeInvoiceDetails.invoiceId}/charge`;
        }
        const invoiceApiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url,
            data: { customerPaymentId: this.customerPaymentId },
            timeout: 50000,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<any>(invoiceApiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_INVOICE_PAID'),
                title: 'Success!',
                timeout: 5000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.showPayInvoiceModal = false;
            this.close();
        } else {
            this.errorMessage = CommonUtils.translateErrorCode(response.errorCode);
        }
    }

    private deleteSurchargeByName(particulars: Particular[], surchargeName: string): SurchargeItem | undefined {
        for (const particular of particulars) {
            if (particular.breakup && particular.breakup.surcharges) {
                const surchargeIndex = particular.breakup.surcharges.findIndex(
                    (item) => item.description === surchargeName,
                );
                if (surchargeIndex !== -1) {
                    const [deletedSurcharge] = particular.breakup.surcharges.splice(surchargeIndex, 1);
                    return deletedSurcharge;
                }
            }
        }
        return undefined;
    }

    private async getUpdatedTotalAmount(invoiceIds: string[]) {
        const iHttpService = ObjectFactory.getHttpService();
        const queryRecordsRequest: any = {
            limit: 1000,
            conditions: [{
                op: 'in',
                fieldName: 'invoiceId',
                value: invoiceIds,
            }],
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_INVOICE}/${this.$props.chargeInvoiceDetails.organizationId}/getmonthlyInvoiceList`,
            data: queryRecordsRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<any[]>(apiRequest);
        if (response.success && response.data) {
            this.updatedAmount = 0 as any;
            response.data.forEach( (invoice) => {
                if (invoice.status === 'Pending') {
                    this.updatedAmount += invoice.amount;
                }
            });
            if (this.updatedAmount !== null) {
                this.updatedAmountIn$ = MathUtils.formatCurrencyWithoutRound(this.updatedAmount as any);
            }
        }
    }

     private async getBillingLocationsDetails(billingLocationIds: []) {
        if (billingLocationIds && billingLocationIds.length > 0) {
            const allLocations: any[] = [];

            for (const locationId of billingLocationIds) {
                const response = await ObjectFactory.getOrganizationService()
                .getLocationDetails(this.$store.state.serverUrl, locationId);
                if (response.data) {
                    allLocations.push(response.data);
                }
            }
            this.billingLocations = allLocations;
        }
    }
}
